export default __webpack_public_path__ + "static/media/amazon.cd0eb3af.png";